import { createApp } from 'vue'
import ElementPlus, { ElMessage } from 'element-plus'
import zhCn from 'element-plus/es/locale/lang/zh-cn'

import App from './App.vue'
import router from './router'
import createPermissionGuard from './router/permissionGuard'
import { setupStore } from './store'
import SvgIcon from '@/components/SvgIcon.vue'
import { useUsageHeartbeat } from '@/hooks/useUsageHeartbeat'
import '@/utils/fetch';
import './styles/index.scss'
import { startPdfPreload } from '@/utils/pdfPreloader'

const app = createApp(App)
app.component('svg-icon', SvgIcon)
app.use(ElementPlus, { locale: zhCn })
setupStore(app)
app.use(router)

app.config.globalProperties.$message = ElMessage
app.mount('#app') 
createPermissionGuard(router)
useUsageHeartbeat(router)

// 启动PDF预加载
startPdfPreload()
